import React from 'react'
import { Badge } from 'react-bootstrap';
import "./statusChip.css";

export default function StatusChip({ bg,pill, title, className, onClick }) {
    return (
        <Badge 
            bg={bg} 
            pill={pill}
            onClick={onClick}
            style={{ cursor: onClick ? 'pointer' : 'default' }}
            className={` fw-medium rounded-1 custom-status-chip ${className}`}
        >
            {title}
        </Badge>
    )
}
